import { Component, computed, inject, input, OnDestroy, output } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';

import { NotificationDto, NotificationCategory } from '../../shared/models/models';
import { LoadingCardComponent } from '../../../shared/components/loading-card.component/loading-card.component';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { NotificationCardComponent } from '../notification-card/notification-card.component';
import { NotificationMessageCardComponent } from '../notification-message-card/notification-message-card.component';
import { TranslatePipe } from '@next/core-lib/i18n';

@Component({
    selector: 'app-notifications-container',
    templateUrl: './notifications-container.component.html',
    styleUrls: ['./notifications-container.component.scss'],
    imports: [
        LoadingCardComponent,
        MatButton,
        MatIcon,
        NotificationCardComponent,
        NotificationMessageCardComponent,
        TranslatePipe,
    ],
})
export class NotificationsContainerComponent implements OnDestroy {
  notifications = input<NotificationDto[]>([]);
  dismissedNotifications = input<NotificationDto[]>([]);
  isLoading = input<boolean>(false);
  notificationDismissed = output<NotificationDto>();

  private readonly destroy$ = new Subject<void>();

  // Split notifications by category
  warnings = computed(() =>
    this.notifications().filter((n) => n.category === NotificationCategory.Warning),
  );

  messages = computed(() =>
    this.notifications().filter((n) => n.category === NotificationCategory.Message),
  );

  // Check if there are any dismissed warnings
  hasDismissedWarnings = computed(() =>
    this.dismissedNotifications().some((n) => n.category === NotificationCategory.Warning),
  );

  // Check if there are any dismissed messages
  hasDismissedMessages = computed(() =>
    this.dismissedNotifications().some((n) => n.category === NotificationCategory.Message),
  );

  private readonly router = inject(Router);

  constructor() { }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onNotificationDismissed(notification: NotificationDto): void {
    this.notificationDismissed.emit(notification);
  }

  navigateToHistory(tab?: 'warnings' | 'messages'): void {
    const queryParams = tab ? { tab } : {};
    this.router.navigate(['/tga/notifications/history'], { queryParams });
  }
}
